export const sampleText = '# Titre\n## Sous-Titre \n### Titre plus profond\n \nLes paragraphes sont séparés\npar une ligne vide.\n\nLaissé deux espaces à la fin d\'une ligne pour  \naller à la ligne.\n\nAttributs *italique*, **gras**, \n`monospace`, ~~rayé~~.\n\nListe:\n\n  * pommes\n  * oranges\n  * poires\n\nListe numérotée:\n\n  1. bleu\n  2. blanc\n  3. rouge\n\n *[Maxime Killinger](https://maxime.killinger.fr/)* \n\n```\n console.log("hello"); \n``` ';


/** WEBPACK FOOTER **
 ** ./src/sampleText.js
 **/